import ProjectSuitabilityConfigContent from './ProjectSuitabilityConfigContent'

export default ProjectSuitabilityConfigContent
